module.exports = __webpack_public_path__ + "static/image/history/m/202209@3x.ver2_0_2.jpg?0edd0780";